import * as echarts from "echarts";

export default {
  created() {
  },
  mounted() {
    const chart = echarts.init(this.$el)
    window.addEventListener('resize', () => {
      setTimeout(() => {chart.resize()}, 10)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', () => chart.resize())
      chart.dispose()
    })
    this.chart = chart
    this.$nextTick(function () {
      this.update()
    })
  },
}
